import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import FocusServiceCard from "../../../components/cards/FocusServiceCard";
import Image from "../../image";

const ProgramBeyondBorders = ({
  featuredImage,
  blockListContainerClass = "flex flex-col md:flex-row w-full md:gap-16 sm:w-11/12",
  imageContainerClass = "h-full w-auto pt-4 sm:pt-0 flex-1"
}) => {
  const { sectionDetails } = useStaticQuery(graphql`
    query {
      sectionDetails: wp {
        ingoPrograms: acfOptionsIngoProgramsConfig {
          ingoPrograms {
            journeysBbHeading
            beyondBordersList {
              journeysBbDesc
              journeysBbTitle
              journeysBbIcon {
                ...smallGalleryData
              }
            }
          }
        }
      }
    }
  `);

  const beyondBordersDetails = sectionDetails?.ingoPrograms?.ingoPrograms ?? {};

  return (
    <>
      <section className="w-full mr-auto md:mb-5 tab-content">
        <div className="flex flex-col md:flex-row pb-5">
          <div className="flex flex-col w-full sm:w-2/3">
            <h6
              className="font-light planet:font-bold text-xl md:text-xlrg-sm planet:text-gray-dark pt-8 pb-5"
              dangerouslySetInnerHTML={{
                __html: beyondBordersDetails?.journeysBbHeading
              }}
            />
            <div className={blockListContainerClass}>
              {beyondBordersDetails?.beyondBordersList &&
                beyondBordersDetails?.beyondBordersList.length > 0 &&
                beyondBordersDetails?.beyondBordersList.map(
                  (include, index) => (
                    <FocusServiceCard
                      key={index}
                      title={include.journeysBbTitle}
                      description={include.journeysBbDesc}
                      icon={include.journeysBbIcon}
                      containerClass="max-w-sm gvi-fservice-card flex flex-col h-full py-4"
                      contentClass="flex flex-col h-full"
                      contentTitleClass="w-full pb-2 text-xl font-normal font-alice text-generic-text planet:text-white "
                      descriptionClass="text-generic-text planet:text-gray-generic xxs:text-xs"
                      imageOuterContainerClass="fservice-card-icon w-[54px] h-14"
                      titleClass=""
                      imageClass=""
                      imageContainerClass=""
                    />
                  )
                )}
            </div>
          </div>

          {featuredImage && featuredImage?.sourceUrl && (
            <div className={`flex borders-image ${imageContainerClass}`}>
              <Image
                imageAlt={""}
                image={featuredImage?.sourceUrl}
                imageClass={`row-span-1 col-span-2 sm:col-span-1 object-cover object-center w-full rounded-md sm:rounded-t-none sm:rounded-b-md`}
                sourceUrl={featuredImage?.sourceUrl}
              />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ProgramBeyondBorders;
